import {
  CHROME_BRAND_ID,
  CHROME_HEADER_ID,
  CHROME_MINIMIZE_ID,
  CHROME_TEAM_ID,
  FRAME_HEADER_FILL,
  PANEL_HEADER,
  SEND_BTN_CLASS,
} from './constants';

const HIDE_TOOLTIPS = `
  [role="tooltip"],
  .tawk-tooltip:not(button):not([role="button"]):not(nav),
  div.tawk-tooltip-hover:not(button):not(nav),
  span.tawk-tooltip-hover:not(button) {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    pointer-events: none !important;
  }
`;

function toolbarNavCss(kind, extras = '') {
  return `
    .tawk-toolbar [role="navigation"][aria-label="${kind}"],
    .tawk-toolbar-nav[aria-label="${kind}"]${kind === 'primary' ? ', .tawk-route-back' : ''} {
      display: flex !important;
      align-items: center !important;
      visibility: visible !important;
      opacity: 1 !important;
      flex: 0 0 auto !important;
      ${kind === 'primary' ? 'margin-left: auto !important;' : ''}
      pointer-events: auto !important;
    }
    .tawk-toolbar [role="navigation"][aria-label="${kind}"] > button,
    .tawk-toolbar [role="navigation"][aria-label="${kind}"] > [role="button"],
    .tawk-toolbar-nav[aria-label="${kind}"] > button${kind === 'primary' ? ', .tawk-route-back button, .tawk-route-back [role="button"]' : ''} {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      visibility: visible !important;
      opacity: 1 !important;
      color: #ffffff !important;
      background: transparent !important;
      pointer-events: auto !important;
    }
    .tawk-toolbar [role="navigation"][aria-label="${kind}"] i,
    .tawk-toolbar [role="navigation"][aria-label="${kind}"] svg,
    .tawk-toolbar [role="navigation"][aria-label="${kind}"] .tawk-icon${kind === 'primary' ? ', .tawk-route-back i, .tawk-route-back svg, .tawk-route-back .tawk-icon' : ''} {
      display: inline-block !important;
      color: #ffffff !important;
    }
    ${extras}
  `;
}

export function themeVarsCss(primary) {
  return `
    :root {
      --tawk-header-background-color: ${primary} !important;
      --tawk-header-background-color-alpha: ${primary}50 !important;
      --tawk-header-text-color: #ffffff !important;
      --tawk-header-color: #ffffff !important;
      --tawk-primary-color: ${primary} !important;
    }
    ${HIDE_TOOLTIPS}
  `;
}

export function themeCss(theme) {
  const header = PANEL_HEADER || theme.primary;
  return `
    ${themeVarsCss(header)}
    html, body {
      color-scheme: light;
      margin: 0 !important;
      padding: 0 !important;
      background: transparent !important;
      overflow: hidden !important;
    }
    html::before,
    html::after {
      content: '';
      position: fixed;
      left: 0;
      right: 0;
      pointer-events: none;
      z-index: 0;
    }
    html::before {
      top: 0;
      height: ${FRAME_HEADER_FILL};
      background: ${header};
    }
    html::after {
      bottom: 0;
      height: 6rem;
      background: #ffffff;
    }
    body > div {
      background: transparent !important;
      background-color: transparent !important;
    }

    .tawk-card,
    .tawk-card-small:not(.tawk-toolbar) {
      border: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
    }

    .tawk-toolbar.tawk-custom-color,
    .tawk-toolbar.tawk-card-small,
    .tawk-toolbar.tawk-flex,
    .tawk-toolbar.tawk-active,
    .tawk-toolbar {
      position: relative !important;
      z-index: 1 !important;
      display: flex !important;
      flex-direction: row !important;
      align-items: center !important;
      justify-content: flex-start !important;
      gap: 0.5rem !important;
      width: 100% !important;
      min-height: 0 !important;
      height: auto !important;
      margin: 0 !important;
      padding: 2rem 1rem 2rem 1rem !important;
      border: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      background: ${header} !important;
      background-color: ${header} !important;
      color: #ffffff !important;
      box-sizing: border-box !important;
    }
    .tawk-toolbar > * {
      margin: 0 !important;
    }

    .tawk-toolbar .tawk-agent,
    .tawk-toolbar .tawk-agent-image,
    .tawk-toolbar .tawk-avatar {
      display: none !important;
    }

    .tawk-toolbar .tawk-agent-info,
    .tawk-toolbar .tawk-text-truncate,
    .tawk-toolbar h1,
    .tawk-toolbar h2,
    .tawk-toolbar .tawk-text:not(button .tawk-text):not([role="navigation"] *) {
      display: none !important;
    }

    ${toolbarNavCss('primary')}
    ${toolbarNavCss(
      'secondary',
      `
    .tawk-toolbar [role="navigation"][aria-label="secondary"] button[aria-label*="inimize" i],
    .tawk-toolbar [role="navigation"][aria-label="secondary"] button[title*="inimize" i] {
      display: none !important;
    }
      `
    )}

    ${HIDE_TOOLTIPS}

    #${CHROME_HEADER_ID} {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      justify-content: center;
      gap: 0.12rem;
      min-width: 0;
      pointer-events: none;
    }
    .richuel-tawk-title {
      margin: 0;
      font-size: 0.95rem;
      font-weight: 650;
      line-height: 1.2;
      letter-spacing: -0.018em;
      color: #ffffff;
    }
    .richuel-tawk-sub {
      margin: 0;
      font-size: 0.7rem;
      font-weight: 400;
      line-height: 1.35;
      color: rgba(255, 255, 255, 0.7);
    }

    #${CHROME_MINIMIZE_ID} {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 auto;
      align-self: center;
      width: 1.75rem;
      height: 1.75rem;
      margin: 0 0.35rem 0 0 !important;
      padding: 0;
      border: 0;
      border-radius: 50%;
      background: transparent;
      color: #ffffff;
      cursor: pointer;
      pointer-events: auto;
    }
    #${CHROME_MINIMIZE_ID}:hover,
    #${CHROME_MINIMIZE_ID}:focus-visible {
      background: rgba(255, 255, 255, 0.16);
      outline: none;
    }
    #${CHROME_MINIMIZE_ID} svg {
      display: block;
    }

    #${CHROME_TEAM_ID} {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      gap: 0.65rem;
      padding: 0.85rem 1rem 0.7rem;
      background: #ffffff;
      border-bottom: 1px solid #eef1f4;
    }
    .richuel-tawk-avatars {
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }
    .richuel-tawk-avatars img {
      width: 2.25rem;
      height: 2.25rem;
      margin-left: -0.5rem;
      border-radius: 50%;
      object-fit: cover;
      object-position: center top;
      border: 2.5px solid #ffffff;
      box-shadow: 0 2px 6px rgba(8, 55, 82, 0.12);
      background: #dce8f0;
    }
    .richuel-tawk-avatars img:first-child { margin-left: 0; }
    .richuel-tawk-online {
      margin: 0;
      font-size: 0.775rem;
      font-weight: 500;
      line-height: 1.4;
      color: #3d5467;
    }

    .tawk-dropdown-menu,
    .tawk-toolbar-menu .tawk-dropdown-list,
    .tawk-toolbar-menu [class*="dropdown-list"],
    .tawk-toolbar-menu [class*="dropdown-menu"],
    .tawk-dropdown.tawk-toolbar-menu [role="menu"] {
      background: ${header} !important;
      background-color: ${header} !important;
      color: #ffffff !important;
      border: 1px solid rgba(255, 255, 255, 0.35) !important;
    }
    .tawk-dropdown-menu .tawk-button,
    .tawk-dropdown-menu button,
    .tawk-toolbar-menu [role="menuitem"],
    .tawk-toolbar-menu [class*="dropdown-item"],
    .tawk-toolbar-menu a,
    .tawk-toolbar-menu button,
    .tawk-toolbar-menu i,
    .tawk-toolbar-menu span {
      background: transparent !important;
      background-color: transparent !important;
      color: #ffffff !important;
    }
    .tawk-dropdown-menu .tawk-button:hover,
    .tawk-dropdown-menu button:hover,
    .tawk-toolbar-menu [role="menuitem"]:hover,
    .tawk-toolbar-menu [class*="dropdown-item"]:hover,
    .tawk-toolbar-menu a:hover,
    .tawk-toolbar-menu button:hover {
      background: rgba(255, 255, 255, 0.16) !important;
      background-color: rgba(255, 255, 255, 0.16) !important;
      color: #ffffff !important;
    }

    .tawk-message, .tawk-bubble, [class*="message-bubble"] {
      border-radius: 0.25rem 0.9rem 0.9rem 0.9rem !important;
    }

    .tawk-footer {
      position: relative !important;
      z-index: 1 !important;
      background: #ffffff !important;
      background-color: #ffffff !important;
      margin: 0 !important;
      padding: 10px 12px 6px !important;
      border: 0 !important;
      border-top: 1px solid #eef1f4 !important;
      border-radius: 0 !important;
    }
    #tawk-chatinput-container,
    .tawk-chatinput {
      background: transparent !important;
      padding: 0 !important;
      margin: 0 !important;
    }
    .tawk-chatinput-wrap {
      display: flex !important;
      flex-wrap: nowrap !important;
      align-items: center !important;
      gap: 6px !important;
      min-height: 42px !important;
      padding: 4px 8px 4px 12px !important;
      border: 1px solid #dbe3ea !important;
      border-radius: 10px !important;
      background: #ffffff !important;
    }
    textarea.tawk-chatinput-editor {
      flex: 1 1 auto !important;
      min-width: 0 !important;
      width: auto !important;
      min-height: 36px !important;
      height: 36px !important;
      margin: 0 !important;
      padding: 8px 4px !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: transparent !important;
      color: #1e3442 !important;
      font-size: 14px !important;
      line-height: 20px !important;
      box-shadow: none !important;
      resize: none !important;
    }
    textarea.tawk-chatinput-editor::placeholder {
      color: #aab8c2 !important;
    }
    .tawk-chatinput-action-buttons {
      position: static !important;
      inset: auto !important;
      display: flex !important;
      align-items: center !important;
      flex-shrink: 0 !important;
      gap: 2px !important;
      margin: 0 !important;
    }
    .tawk-chatinput-button[title="Rate this chat"] {
      display: none !important;
    }
    .tawk-chatinput-button[title="Insert emoji"] {
      width: 36px !important;
      height: 36px !important;
      padding: 0 !important;
      border: 0 !important;
      border-radius: 50% !important;
      background: transparent !important;
      color: #8fa0af !important;
    }
    .tawk-icon-emoji,
    .tawk-icon.tawk-icon-emoji,
    .tawk-chatinput-button[title="Insert emoji"] .tawk-icon,
    .tawk-chatinput-button[title="Insert emoji"] i,
    .tawk-chatinput-button[title="Insert emoji"] svg {
      width: 22px !important;
      height: 22px !important;
      font-size: 22px !important;
      line-height: 1 !important;
    }
    .tawk-chatinput-button[title="Upload File"],
    .tawk-chatinput-button[aria-label="Upload File"],
    .tawk-chatinput-button[data-text="Upload File"],
    .tawk-chatinput-fileupload,
    .tawk-chatinput-fileupload-input,
    .tawk-chatinput-fileupload-list,
    .tawk-chatinput-fileupload-preview,
    input[type="file"] {
      display: none !important;
      pointer-events: none !important;
    }
    .tawk-chatinput-send-container,
    .tawk-chatinput-wrap .tawk-chatinput-send,
    .${SEND_BTN_CLASS} {
      display: none !important;
    }

    a[href*="tawk.to"],
    .tawk-branding,
    .tawk-footer-branding {
      display: none !important;
    }

    #${CHROME_BRAND_ID} {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.3rem;
      margin: 0;
      padding: 0.4rem 0 0.5rem;
      background: #ffffff;
      font-size: 0.68rem;
      font-weight: 500;
      letter-spacing: 0.02em;
      color: #aab8c2;
    }
    #${CHROME_BRAND_ID} svg {
      display: block;
      flex-shrink: 0;
    }
  `;
}
